import axios from 'axios'
import { fetchUtil } from "../Hooks/fetchUtil";
import { useLoading } from '../context/LoadingContext';

export class AuthServices {

    requestPost(body, indexUrl) {
        const { url, apiLambda } = fetchUtil();
        const f = new FormData();
        let urlRq;
        let headers;
        if (apiLambda) {
            headers = {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
            }
            f.append('urlPath', `${url[indexUrl].urlDominioServidor}${url[indexUrl].pathLambda}`);
            f.append('body', JSON.stringify(body))
            urlRq = `${url[indexUrl].urlEntornoLambda}`;
        } else {
            headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            urlRq = `${url[indexUrl].urlEntornoLocal}${url[indexUrl].pathLambda}`;
        }
        const rqBody = apiLambda ? f : body;
        return new Promise((resolve) => {
            axios.post(urlRq, rqBody, {
                headers
            }).then((response) => {
                resolve({
                    data: response.data,
                    error: null
                })
            }).catch((error) => {
                resolve({
                    data: [],
                    error: error
                })
            })
        })
    }

}

export const useAuthServices = () => {
    const { setCargando } = useLoading();
    const authServices = new AuthServices();

    const requestPost = async (body, indexUrl) => {
        setCargando(true);
        const response = await authServices.requestPost(body, indexUrl);
        setCargando(false);
        return response;
    };

    return { requestPost };
};
